import React from 'react'
import styled from 'styled-components'
import colours from '../lib/colours'
import { MobileDeviceWidth } from '../lib/constants'

const StyledDiv = styled.div`
  position: absolute;
  min-width: 20px;
  min-height: 30px;
  padding: 10px;
  bottom: 30px;
  left: 15px;
  z-index: 1;
  color: ${colours.whiteText};
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.25);
  background: white;
  margin-top: 90px;
  @media (max-width: ${MobileDeviceWidth}px) {
    margin-top: 0;
    width: 100%;
    left: 40px;
    right: 0;
    transform: inherit;
  }
`
const MapOverlayControl = props => {
  return <StyledDiv>{props.children}</StyledDiv>
}

export default MapOverlayControl
